import React, { Component } from 'react';
import * as flat from 'flat';

import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import LinearProgress from '@material-ui/core/LinearProgress';
import { Accordion, ValueControl } from 'sm-react-components';

import mixpanel, { Events as MPEvents } from '../../infrastructure/mixpanel';
import Error from '../components/Error';
import * as requests from '../../infrastructure/requests';

const styles = theme => ({
    field: { width: 100 },
    operator: { ...theme.typography.subtitle1, paddingRight: '5px' }
});

class Quota extends Component {
  state = {
      loading: false,
      error: undefined,
      quota: undefined,
      modified: false,
      saving: false
  };

  load = async () => {
      const { id, userId } = this.props;
      try {
          this.setState({ loading: true });
          if (id !== undefined) {
              this.setState({
                  quota: await requests.getQuota(id),
                  loading: false,
                  modified: false
              });
          } else if (userId !== undefined) {
              this.setState({
                  quota: await requests.getUserQuota(userId),
                  loading: false,
                  modified: false
              });
          } else {
              this.setState({
                  error: 'No id or UserId provided',
                  loading: false
              });
          }
      } catch (error) {
          this.setState({
              error: error.message,
              loading: false
          });
      }
  };

  save = async () => {
      try {
          this.setState({ saving: true });
          await requests.postQuota({
              ...this.state.quota,
              key: this.props.id,
              user: this.props.userId,
              updated: undefined,
              dailyUsed: undefined
          });
          this.setState({ saving: false, modified: false });
          mixpanel.track(MPEvents.CONSOLE_KEYS_QUOTA_SAVE, {
              key_id: this.props.id
          });
      } catch (error) {
          this.setState({
              error: error.message,
              saving: false
          });
      }
  };

  componentDidMount() {
      this.load();
  }

  changeLimit = (context, path, newValue) => {
      const obj = this.state.quota[context];
      const keys = flat.flatten(obj, { maxDepth: 2 });
      keys[path].value = newValue;
      this.setState({
          quota: {
              ...this.state.quota,
              [context]: flat.unflatten(keys)
          },
          modified: true
      });
      this.save();
  };

  content = (obj, key1, context) => {
      return Object.keys(obj[key1]).map(
          (key, index) =>
              key !== 'enabled' && (
                  <ValueControl
                      key={`value-control-${key1}-${key}`}
                      label={key}
                      value={obj[key1][key].value}
                      onValueChange={value =>
                          this.changeLimit(context, `${key1}.${key}`, value)
                      }
                  />
              )
      );
  };

  header = text => {
      return (
          <div style={{ height: '33px', display: 'flex', alignItems: 'center' }}>
              <Typography
                  style={{
                      fontSize: '14px',
                      fontWeight: 'bold',
                      color: '#58606A',
                      lineHeight: '14px',
                      height: '14px'
                  }}
              >
                  {text}
              </Typography>
          </div>
      );
  };

  table = quota => {
      //const limits = flat.flatten(quota, { maxDepth: 2 });
      const { limits, daily } = quota;
      return (
          <div>
              {Object.keys(limits)
                  .sort()
                  .map((key1, _) => (
                      <Accordion
                          key={`accordion-${key1}`}
                          defaultExpanded={true}
                          header={
                              <div style={{ display: 'flex', width: '100%' }}>
                                  <Typography
                                      style={{
                                          fontSize: '14px',
                                          fontWeight: 'bold',
                                          color: '#333940',
                                          lineHeight: '14px',
                                          width: '35%',
                                          paddingRight: '5%'
                                      }}
                                  >
                                      {key1}
                                  </Typography>
                                  <Typography
                                      style={{
                                          fontSize: '14px',
                                          color: '#ABABAB',
                                          lineHeight: '14px',
                                          width: '60%'
                                      }}
                                  >
                                      {limits[key1]['enabled'].value ? 'Active' : 'Inactive'}
                                  </Typography>
                              </div>
                          }
                          content={
                              <React.Fragment>
                                  <ValueControl
                                      key={`value-control-${key1}-enabled`}
                                      label={'enabled'}
                                      value={limits[key1]['enabled'].value}
                                      onValueChange={value =>
                                          this.changeLimit('limits', `${key1}.enabled`, value)
                                      }
                                  />
                                  {this.header('Daily Quota')}
                                  {this.content(daily, key1, 'daily')}
                                  {this.header('Limits Quota')}
                                  {this.content(limits, key1, 'limits')}
                              </React.Fragment>
                          }
                      />
                  ))}
          </div>
      );
  };

  render() {
      const { loading, error, quota, saving } = this.state;
      return (
          <React.Fragment>
              {(loading || saving) && <LinearProgress />}
              {!(loading || saving) && <div style={{ height: '5px' }} />}
              {error && <Error message={error} />}
              {quota !== undefined && this.table(quota)}
          </React.Fragment>
      );
  }
}

export default withStyles(styles)(Quota);
